import { observer } from "mobx-react-lite";
import { BoxProps, Flex, Button, ChakraProps } from "@chakra-ui/react";

import { FillType } from "@noli/svg";
import { useBackground, useBackgroundCaches } from "@noli/business";

import SubPanel from "@/components/SubPanel";
import SVGEditor from "./SVGEditor";
import ImageEditor from "./ImageEditor";
import { SvgColorsPanel } from "./common";

function BackgroundPanel({ children, ...others }: BoxProps) {
  const { type, toSvg, toColor, toImage } = useBackground();
  const { svg, image } = useBackgroundCaches();

  const buttonProps: ChakraProps = {
    w: "25%",
    h: "24px",
    mt: "8px",
    mb: "12px",
  };
  return (
    <Flex w="100%" h="100%" direction="column" {...others}>
      <SubPanel
        panelTitle="切换背景类型"
        w="100%"
        h="100px"
        pt="16px"
        borderTop="1px"
        borderColor="#eee"
      >
        <Flex w="100%" h="100%" px="8px" mt="4px" justifyContent="space-around">
          <Button {...buttonProps} variant="text" size="sm">
            图片
          </Button>
          <Button {...buttonProps} variant="text" size="sm">
            SVG
          </Button>
          <Button
            {...buttonProps}
            variant="text"
            size="sm"
            onClick={() =>
              toColor({ trace: true })({
                type: FillType.SOLID,
                color: "#FFFFFF",
                opacity: 1.0,
              })
            }
          >
            颜色
          </Button>
        </Flex>
      </SubPanel>
      {children}
    </Flex>
  );
}
function BackgroundEditor() {
  const { type } = useBackground();
  return (
    <BackgroundPanel>
      {type === "svg" ? (
        <SVGEditor flex={1} overflow="hidden" />
      ) : type === "color" ? (
        <SvgColorsPanel />
      ) : type === "image" ? (
        <ImageEditor flex={1} overflow="hidden" />
      ) : null}
    </BackgroundPanel>
  );
}

export default observer(BackgroundEditor);
